<template>
  <div
    class="btn-outside"
    :class= "{
      red: isActive,
    }"
  >
    <a href="#" @click.prevent="click">
      <img
        :src="isActive ? icons.TrashRedIcon: icons.TrashIcon"
        alt="削除アイコン"
        class="ico-base"
      >
      <slot></slot>
    </a>
  </div>
</template>

<script>
import {
  TrashRedIcon,
  TrashIcon,
} from "icons";

export default {
  name: "TrashLink",
  props: {
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      icons: {
        TrashRedIcon,
        TrashIcon,
      },
    };
  },
  methods: {
    click() {
      if (this.isActive) {
        this.$emit("destroy");
      }
    },
  },
};
</script>
